import { useEffect, useLayoutEffect } from 'react';

/**
 * Runs measure on content deps and window resize. No ResizeObserver — measuring
 * the same element you observe causes "ResizeObserver loop" errors on keystrokes.
 */
export function useAutosizeTextarea(measure, deps) {
  useLayoutEffect(() => {
    measure();
    // deps are caller content values (e.g. textarea text); spread is intentional
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [measure, ...deps]);

  useEffect(() => {
    const onWin = () => measure();
    window.addEventListener('resize', onWin);
    return () => window.removeEventListener('resize', onWin);
  }, [measure]);
}
